<template>
  <m-pay-layout>
    <v-layout :column="$vuetify.breakpoint.smAndDown">

      <m-pay-confirm-dialog
        :show="showConfirmationDialog"
        :title="confirmationDialog.description"
        @yes="confirmationDialog.action"
        @cancel="hideDialog"
        maxWidth="700px"
      />

      <v-flex grow>
        <v-card>
          <v-card-title>
            <span class="headline">Merchant Active Certificates</span>
          </v-card-title>
          <m-pay-generic-paging-table
                       :headers="headers"
                       :queryFunctionName="queries.userMerchantCertificates.name"
                       :cellClasses="cellClasses"
                       :key="certificateUpdates"
                     >
            <template slot-scope={item} slot="details">
              <router-link :to="{ name: 'cert', params: { certificateId: item.id } }">
                <v-tooltip bottom>
                      <span slot="activator">
                        <v-icon color="secondary">zoom_in</v-icon>
                      </span>
                  <span>Certificate Details</span>
                </v-tooltip>
              </router-link>
            </template>
          </m-pay-generic-paging-table>
          <v-btn class="ml-0"
               color="secondary"
               @click.native="confirmAndGenerateCertificate">
            Generate new certificate
            <v-icon right dark>add</v-icon>
          </v-btn>
        </v-card>
       </v-flex>

       <v-flex class="mb-3 mx-2">
        <v-card class="mb-2" v-if="serviceProviderCertificate">
          <v-card-title>
            <span class="headline">Service Provider Certificate info</span>
          </v-card-title>
          <v-card-text>
            <v-text-field label="Created At"
                          readonly
                          :value="formatDateTime(serviceProviderCertificate.createdDate)"
            ></v-text-field>
            <v-text-field label="Created By"
                          readonly
                          :value="serviceProviderCertificate.createdBy"
            ></v-text-field>
            <v-text-field label="Expiration date"
                          readonly
                          :value="formatDate(serviceProviderCertificate.expirationDate)"
            ></v-text-field>
            <v-textarea label="Public key"
                        readonly rows="10"
                        :value="serviceProviderCertificate.publicKey"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="secondary"
                   v-clipboard="serviceProviderCertificate.publicKey">
              Copy Public Key
            </v-btn>
          </v-card-actions>
        </v-card>

        <v-card class="mb-2" v-if="merchantApiKey">
          <v-card-title>
            <span class="headline">Merchant Api key info</span>
          </v-card-title>
          <v-card-text>
            <v-text-field label="Created At"
                          readonly
                          :value="formatDateTime(merchantApiKey.createdDate)"
            ></v-text-field>
            <v-text-field label="Created By"
                          readonly
                          :value="merchantApiKey.createdBy"
            ></v-text-field>
            <v-text-field label="Api key"
                        readonly
                        :value="merchantApiKey.key"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="secondary"
                   v-clipboard="merchantApiKey.key">
              Copy Api Key
            </v-btn>
            <v-btn flat color="secondary"
                   :loading="loading"
                   :disabled="loading"
                   @click.native="confirmAndGenerateApiKey">
              Generate new api key
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

    </v-layout>
  </m-pay-layout>
</template>

<script>
import axios from 'axios';
import formatters from '../../utils/formatters';
import queries from '../../utils/queries';
import MPayErrorMessage from '../MPayErrorMessage';
import MPayCopyButton from '../MPayCopyButton';
import MPayConfirmDialog from '../MPayConfirmDialog';
import MPayGenericPagingTable from '../MPayGenericPagingTable';

export default {
  name: 'MPayMerchantCertificatesView',
  components: { MPayCopyButton, MPayErrorMessage, MPayConfirmDialog, MPayGenericPagingTable },
  data: () => ({
    loading: false,
    merchantCertificate: null,
    certificateUpdates: 0,
    serviceProviderCertificate: null,
    merchantApiKey: null,
    merchant: {},
    showConfirmationDialog: false,
    confirmationDialog: {
      title: '',
      description: '',
      action: {},
    },
    headers: [
      { text: '', value: 'details', sortable: false, filterable: false },
      { text: 'Name', value: 'name' },
      { text: 'Expires', value: 'expirationDate' },
      { text: 'Created', value: 'createdDate' },
      { text: 'Creator', value: 'createdBy' },
    ],
    cellClasses: {
      details: 'pl-3 pr-1',
    },
  }),
  methods: {
    fetchMerchant() {
      this.loading = true;
      axios.get(queries.userMerchant())
        .then((response) => {
          this.merchant = response.data;
          this.loading = false;
          this.fetchServiceProviderCertificate();
          this.fetchApiKeyInfo();
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
    },
    fetchCertificateInfo() {
      this.loading = true;
      axios.get(queries.userMerchantCertificate())
        .then((response) => {
          this.merchantCertificate = response.data;
          this.loading = false;
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
    },
    fetchServiceProviderCertificate() {
      this.loading = true;
      axios.get(queries.serviceProviderCertificate())
        .then((response) => {
          this.serviceProviderCertificate = response.data;
          this.loading = false;
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
    },
    fetchApiKeyInfo() {
      this.loading = true;
      axios.get(queries.userMerchantApiKey())
        .then((response) => {
          this.merchantApiKey = response.data;
          this.loading = false;
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
    },
    generateCertificate() {
      this.loading = true;
      axios.post(queries.userMerchantCertificate())
        .then((response) => {
          // file name and content type
          const cd = response.headers['content-disposition'];
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const definedFilename = filenameRegex.exec(cd);
          const filename = definedFilename[1] || 'private-key.pem';
          const contentType = response.headers['content-type'] || 'application/octet-stream';

          this.saveData(response.data.privateKey, filename, contentType);
          this.certificateUpdates += 1;
        })
        .catch((e) => {
          this.showError(e);
        })
        .finally(() => {
          this.loading = false;
          this.hideDialog();
        });
    },
    generateApiKey() {
      this.loading = true;
      axios.post(queries.userMerchantApiKey())
        .then(() => {
          setTimeout(this.fetchApiKeyInfo, 1000);
        })
        .catch((e) => {
          this.showError(e);
        })
        .finally(() => {
          this.loading = false;
          this.hideDialog();
        });
    },
    confirmAndGenerateCertificate() {
      this.showDialog('This will invalidate current connection configuration ' +
        'and recreate certificate. Are you sure?', this.generateCertificate);
    },
    confirmAndGenerateApiKey() {
      this.showDialog('This will invalidate current connection configuration ' +
        'and recreate api key. Are you sure?', this.generateApiKey);
    },
    formatDate(timestamp) {
      return formatters.date(timestamp);
    },
    formatDateTime(timestamp) {
      return formatters.dateTime(timestamp);
    },
    showDialog(message, onSuccessCallback) {
      this.showConfirmationDialog = true;
      this.confirmationDialog = {
        title: '',
        description: message,
        action: onSuccessCallback,
      };
    },
    hideDialog() {
      this.showConfirmationDialog = false;
    },
    saveData(data, fileName, contentType) {
      const a = document.createElement('a');
      a.style = 'display: none';
      document.body.appendChild(a);

      const blob = new Blob([data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    },
  },
  created() {
    this.fetchMerchant();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/merchant/MPayMerchantCertificatesView.vue